import React from 'react'
import { IFSkeleton } from 'Components'
import Styles from './CardUsageStats.module.css'

const CardUsageStatsSkeleton = () => {
  return (
    <>
      <div className={Styles.Tiles}>
        {[0, 1, 2].map((index) => (
          <IFSkeleton
            key={`CardUsageStatsTileSkeleton-${index}`}
            variant="rectangular"
            width="100%"
            height={78}
            style={{ borderRadius: 8 }}
          />
        ))}
      </div>
      <div className={Styles.ChartContainer}>
        <IFSkeleton
          variant="rectangular"
          width="100%"
          height={160}
          style={{ borderRadius: 8 }}
        />
      </div>
    </>
  )
}

export default CardUsageStatsSkeleton
